import { gameConfig } from '../../../gameConfig';
import { IArticle, SpecialTags } from '../../../types/articleTypes';

export function findSeriesLink(article: IArticle) {
  const routes = gameConfig.Routes;

  const series = [
    ...(routes.WeeklyRoutes ? [{ tag: SpecialTags.WeeklyRoute, path: routes.WeeklyRoutes }] : []),
    ...(routes.PlayLikeThePros ? [{ tag: SpecialTags.PlayLikeThePros, path: routes.PlayLikeThePros }] : [])
  ];

  if (article.tags) {
    for (const seriesObj of series) {
      if (article.tags.includes(seriesObj.tag)) {
        return seriesObj.path;
      }
    }
  }

  return article.path || article.url!;
}
